"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _index = _interopRequireDefault(require("../index"));
var securedHashVersion = "v2";
var _default = exports["default"] = {
  hash: function hash(_ref) {
    var _ref$username = _ref.username,
      username = _ref$username === void 0 ? null : _ref$username,
      _ref$sub = _ref.sub,
      sub = _ref$sub === void 0 ? null : _ref$sub,
      _ref$token = _ref.token,
      token = _ref$token === void 0 ? null : _ref$token;
    var headers = {};
    if (token) {
      headers.Authorization = "Bearer ".concat(token);
    }
    var payload = {};
    if (username) payload.username = username;
    if (sub) payload.sub = sub;
    return _index["default"].post("/".concat(securedHashVersion, "/auth/password/hash"), _qs["default"].stringify(payload), {
      headers: headers
    });
  }
};